import { PurchaseRequestDto } from '../../constants/types/purchase-type';

// 결제화면용
export const purchase_valid = (data: PurchaseRequestDto) => {
  if (!data.address_1)
    return { flag: false, message: '기본주소를 입력하지 않았습니다. 기본주소를 입력해주세요.' };
  if (!data.address_2)
    return { flag: false, message: '상세주소를 입력하지 않았습니다. 상세주소를 입력해주세요.' };
  if (!data.contact_no)
    return { flag: false, message: '연락처를 입력하지 않았습니다. 연락처를 입력해주세요.' };
  if (!data.message)
    return { flag: false, message: '배송메시지를 입력하지 않았습니다. 배송메시지를 입력해주세요.' };
  if (!data.post_code)
    return { flag: false, message: '우편번호를 입력하지 않았습니다. 우편번호를 입력해주세요.' };
  if (!data.receiver)
    return { flag: false, message: '배송지를 입력하지 않았습니다. 배송지를 입력해주세요.' };
  if (!data.payment_method)
    return { flag: false, message: '결제방식을 선택하지 않았습니다. 결제방식을 선택해주세요.' };

  return { flag: true, message: '' };
};
